import React, { useRef } from "react";
import { createRoot } from "react-dom/client";
import {
  ApplePayButton,
  abortApplePaySession,
} from "@tap-payments/apple-pay-button";

const ApplePayTapSDK = (props) => {
  const SaveApplePayPayment = async (json) => {
    const url =
      process.env.REACT_APP_PAYMENT_API + "Payment/SaveApplePayPayment";
    const data = {
      Json: json,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch payment requests");
      }

      const result = await response.json();

      return result;
    } catch (error) {
      console.error("Error fetching payment requests:", error);
    }
  };
  const onReadyCount = useRef(0);
  return (
    <ApplePayButton
      debug={process.env.REACT_APP_DEBUG}
      scope="TapToken"
      publicKey={process.env.REACT_APP_BUNDLE_ID}
      environment={process.env.REACT_APP_APPLE_ENV}
      merchant={{
        domain: process.env.REACT_APP_APPLE_DOMAIN,
        id: process.env.REACT_APP_APPLE_MERCHANT_ID,
      }}
      acceptance={{
        supportedBrands: ["masterCard", "visa"],
      }}
      features={{
        supportsCouponCode: false,
      }}
      transaction={{
        currency: "BHD",
        amount: props.amount.toString(),
      }}
      customer={{
        id: props.custId,
      }}
      interface={{
        locale: "en",
        theme: "dark",
        type: "buy",
        edges: "curved",
      }}
      onCancel={() => {
        // it's called when the user cancels the payment
        console.log("onCancel");
      }}
      onError={(error) => {
        console.error("Apple Pay Error:", error);

        // Try to extract more details from error object
        let message = "";
        if (error.response && error.response.data) {
          message = JSON.stringify(error.response.data, null, 2);
        } else if (error.message) {
          message = error.message;
        } else {
          message = JSON.stringify(error, null, 2);
        }

        alert("Apple Pay Error:\n" + message);
      }}
      onReady={() => {
        console.log("📡 Apple Pay onReady triggered");

        // Just notify the parent – do NOT update state here
        props.onReady?.(); // bubble up the event
      }}
      onSuccess={async (data, event) => {
        // it's called when the payment is successful
        console.log("onSuccess", data);
        await SaveApplePayPayment(JSON.stringify(data));
        // event is the same as the event in the onpaymentauthorized event https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypaymentauthorizedevent
        console.log("apple pay event", event);
      }}
    />
  );
};

//const root = createRoot(document.getElementById('root')!)
export default ApplePayTapSDK;
